module.exports = __webpack_public_path__ + "media/celebrity-video.eb8b1ecf.mp4";